// extracted by mini-css-extract-plugin
module.exports = {"container":"trending-tag_container__Jr2iO","content":"trending-tag_content__0nUk8","shadow":"trending-tag_shadow__nktnm"};